<template>
  <Bar :data="data" :options="mergedOptions" />
</template>

<script lang="ts">
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { Bar } from "vue-chartjs";
import zoomPlugin from "chartjs-plugin-zoom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);

export default {
  name: "BarChartComponent",
  components: {
    Bar,
  },
  props: {
    data: {
      type: Object,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    mergedOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        ...this.options,
        plugins: {
          ...this.options?.plugins,
          zoom: {
            pan: {
              enabled: true,
              mode: "x", // Drag/pan horizontally
            },
            zoom: {
              wheel: {
                enabled: true, // Scroll-wheel zooming
              },
              pinch: {
                enabled: true, // Touch pinch zooming
              },
              mode: "x",
            },
          },
        },
      };
    },
  },
};
</script>
